import { default as doPersonalModel } from './personalModel';

export {};

export const sagaPersonalModel = doPersonalModel.sagas;
